// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__18iP6","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1I5Xr"};